import { render, staticRenderFns } from "./PassengerFlow.vue?vue&type=template&id=6af34b30&scoped=true&"
import script from "./PassengerFlow.vue?vue&type=script&lang=js&"
export * from "./PassengerFlow.vue?vue&type=script&lang=js&"
import style0 from "./PassengerFlow.vue?vue&type=style&index=0&id=6af34b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af34b30",
  null
  
)

export default component.exports